import { useMemo } from "react";
import { Animated } from "react-native";

import { useTheme } from "../../utils/theme";

import type { ButtonColors } from "./types";

export function LongPress({
  dotSize,
  scale,
  color,
}: {
  dotSize: number;
  scale: Animated.Value;
  color: ButtonColors;
}) {
  const { colors } = useTheme();

  const backgroundColor = useMemo(() => {
    switch (color) {
      case "primary":
        return colors.buttonLongPressTransition;
      case "destructive":
        return colors.buttonLongPressTransitionError;
    }
  }, [
    color,
    colors.buttonLongPressTransition,
    colors.buttonLongPressTransitionError,
  ]);

  return (
    <Animated.View
      style={{
        width: dotSize,
        height: dotSize,
        backgroundColor,
        position: "absolute",
        top: "50%",
        left: "50%",
        marginLeft: -dotSize / 2,
        marginTop: -dotSize / 2,
        borderRadius: dotSize / 2,
        opacity: scale.interpolate({
          inputRange: [dotSize, 20, 100],
          outputRange: [0, 0.5, 1],
        }),
        transform: [
          {
            scale,
          },
        ],
      }}
    />
  );
}
